// extracted by mini-css-extract-plugin
export default {"icon":"tire-attribute-icon-one-dt__icon___1RIAb"};